<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelSearchSummary from '~src/components/search/hotelSearchSummary.src'
    import HotelInfoSearchForm from '~/components/info/forms/HotelInfoSearchForm.vue'

    //TODO Hide if empty searchRequest
    @Component({
        components: {HotelInfoSearchForm},
        mixins: [HotelSearchSummary],
    })
    export class HotelInfoSearchSummary extends Vue {
        get isSearchActive() {
            return hotelsRuntimeStore.singleHotelSearchActive
        }

        get searchFormComponent() {
            return resolveComponent('HotelInfoSearchForm')
        }
    }

    export default {...toNative(HotelInfoSearchSummary), ssrRender: HotelSearchSummary.ssrRender}
</script>
